<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      
      <el-form :inline="true" class="demo-form-inline backborder1" size="small">
          <el-form-item v-if="ismall==1">
      		  <el-select v-model="brandquery.status" filterable clearable placeholder="请选择状态" @change="brandquery.ischange=true">
	              <el-option v-for="(item,index) in statuslists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>
      	  </el-form-item>
      	  <el-form-item ref="query" :model="query">
              <el-input placeholder="请输入关键字" v-model="brandquery.key" clearable @change="brandquery.ischange=true"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="warning" @click="getbrandlists">查询</el-button>
          </el-form-item>
          <el-form-item v-if="actionauth.base_brand_add=='true'">
              <el-button type="warning"  @click="addcreatebrandinfo">新增品牌</el-button>
          </el-form-item>
      </el-form>
      
      <div class="backborder2" style="margin-top:10px">    
      	  <el-table :data="brandquerylists" v-loading="brandlistLoading">
            <el-table-column label="id" width="90">
	          	  <template slot-scope="scope">
	          	  	  <span>{{scope.row.id}}</span>
	          	  </template>
	          </el-table-column>
	          <el-table-column label="品牌图片" width="120">
	          	  <template slot-scope="scope">
                  <div style="border:1px solid #ddd;border-radius:6px;float:left;width:100px;height:60px;background:rgba(0,0,0,.1);display:flex;align-items: center;justify-content: center;">
	          	  	  <img :id="'imginfo'+scope.row.id" :src="scope.row.thumb=='' ? require('../../assets/img-brand-default.png') : scope.row.thumb" style="max-width:100%;max-height:100%;border-radius:6px;"/>
                  </div>
                </template>
	          </el-table-column>
	          <el-table-column label="品牌名称" align="center">
                <template slot-scope="scope">
                  <div style="float:left;width:100%;font-size:13px;text-align:center;">{{scope.row.name}}</div>
                </template>
            </el-table-column>
            <el-table-column label="申请商城授权品牌" align="center" v-if="ismall==1" min-width="120">
                <template slot-scope="scope">
                  <div style="float:left;width:100%;font-size:13px">{{scope.row.sysbrandname ? scope.row.sysbrandname : '-'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="授权结果" align="center" v-if="ismall==1" min-width="120">
                <template slot-scope="scope">
                    <span :style="scope.row.verifystatus==3 ? 'float:left;width:100%;font-size:12px;color:red' : 'float:left;width:100%;font-size:12px;color:#666666'">{{scope.row.status ? scope.row.status : '-'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="授权销售时间" align="center" v-if="ismall==1" min-width="120">
                <template slot-scope="scope">
                  <div style="float:left;width:100%;font-size:13px;overflow:hidden;white-space:nowrap;text-overflow: ellipsis;" v-if="scope.row.verifystatus > 0">
                      {{scope.row.saletime && scope.row.saletime!='' ? scope.row.saletime : '-'}}
                  </div>
                </template>
            </el-table-column>
            <!--
            <el-table-column label="最新审核记录" align="left" v-if="ismall==1" width="200">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" :content="scope.row.verifyreason" placement="top">
                  <div style="float:left;width:100%;font-size:13px;overflow:hidden;white-space:nowrap;text-overflow: ellipsis;">
                      {{scope.row.verifyreason}}
                  </div>
                  </el-tooltip>
                </template>
            </el-table-column>
            -->
              <!--
	          <el-table-column label="是否为精品品牌" width="150" align="center">
	          	  <template slot-scope="scope">
	          	  	  <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="ismallgoods[scope.$index]"  @change="changeismallgoods(scope.$index,scope.row)"></el-switch>
	         	  </template>
	          </el-table-column>
              -->
	          <el-table-column label="操作" min-width="130" align="center">
		          <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="设置品牌授权信息" placement="top" v-if="ismall==1">
                  <el-button type="warning" size="small" round @click="grandbrand(scope.row)" :disabled="scope.row.verifystatus==1 ?  true : false ">申请授权</el-button>
                  </el-tooltip>
		          	  <el-button type="warning" size="small" round  @click="editbrandCurrent(scope.row)" v-if="actionauth.base_brand_update=='true'">编辑</el-button>
		              <el-button type="" size="small" round  @click="delbrandCurrent(scope.row)" v-if="actionauth.base_brand_del=='true'">删除</el-button>
		          </template>
	          </el-table-column>
	     </el-table>
	     <div class="block">
	        <!--分页begin-->
	        <el-pagination
	            @size-change="brandpageSizeChange"
	            @current-change="brandpageCurrentChange"
	            :current-page="brandquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="brandquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="brand_total_rows">
	        </el-pagination>
	        <!--分页end-->
	     </div>
     </div>
     
     <el-dialog title="添加我的品牌" :visible.sync="createbrandDialog" width="34%">
          <input type="file" id="addcoverthumb" @change="adduploadallfiles($event)" style="display:none"/>
          <input type="file" id="addthumb" @change="addthumbuploadallfiles($event)" style="display:none"/>
          <input type="file" id="bannerthumb" @change="adduploadbannerfiles($event)" style="display:none"/>
          <el-form :inline="true" class="brand-mall-infos" label-width="100px" size="small">
              <el-form-item  label="选择品牌" label-width="120" style="width:100%;border-bottom:1px dashed #999999;padding:0 0 10px 0;">
                  <el-select v-model="createbrand.sysbrandid" filterable clearable placeholder="请选择品牌" @change="changeaddthumb">
                      <el-option v-for="(item,index) in sysbrandlists" :label="item.showlable" :value="item.id" :key="index">
                          <span style="float: left">{{item.companyname}}</span>
                          <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                      </el-option>       
                  </el-select>
                  <el-button type="primary" circle size="mini" icon="el-icon-refresh" @click="getsysbrandlists"></el-button>
                  <a @click="addhandlebrands" style="display:inline-block;font-size:12px;color:#666666;font-weight:500;padding:5px 0;cursor:pointer;text-decoration:underline">
                      没有我想要的品牌 ？去手动添加
                  </a>
              </el-form-item>
              <el-form-item label="品牌名称" label-width="120" v-if="createbrand.name!=''" style="width:100%">
                  <div>{{createbrand.name}}</div>
              </el-form-item>
              <el-form-item label="品牌logo" label-width="120" v-if="createbrand.thumb!=''" style="width:100%">
                  <template slot-scope="scope">
                      <img :src="createbrand.thumb=='' ? require('../../assets/default_img.png') : createbrand.thumb" style="float:left;width:80%;border-radius:6px;box-shadow:5px 5px 10px #999999"/>
                  </template>
              </el-form-item>
              <el-form-item label="是否提交平台审核" label-width="160" style="width:100%" v-if="ismall==1">
                  <template slot-scope="scope">
                    <el-radio v-model="createbrand.type" label="2">否</el-radio>
                    <el-radio v-model="createbrand.type" label="1">是</el-radio>
                    <el-tooltip placement="top">
                        <div slot="content">提交平台审核成功的品牌可在线上商城上进行销售</div>
                        <div class="brand-warning-notice">?</div>
                    </el-tooltip>
                  </template>
              </el-form-item>
              <el-form-item  label="品牌类型" label-width="120" v-if="ismall==1 && createbrand.type==1" style="width:100%;padding-top:20px;border-top:1px dashed #999999">
                  <el-select v-model="createbrand.granttype" filterable placeholder="请选择授权方式">
                      <el-option v-for="(item,index) in granttypelists" :label="item.name" :value="item.id" :key="index"></el-option>
                  </el-select>
                  <el-tooltip placement="top">
                      <div slot="content">
                          授权品牌为从品牌方处代理的品牌<br/>
                          自主品牌为自己公司研发的自有品牌
                      </div>
                      <div class="brand-warning-notice">?</div>
                  </el-tooltip>
              </el-form-item>
              <el-form-item label="授权区域" label-width="100" v-if="ismall==1 && createbrand.type==1">
                  <template slot-scope="scope">
                      <el-button type="warning" round size="small" @click="addsettingarea">设置授权区域</el-button>
                  </template>
              </el-form-item>
              <el-form-item label="授权时间" label-width="100" style="width:100%" v-if="ismall==1 && createbrand.type==1 && createbrand.granttype==1">
                  <el-date-picker	v-model="createbrand.date" type="daterange" style="width:100%"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd" :unlink-panels="false">
                  </el-date-picker>
              </el-form-item>
              
              <!--
              <el-form-item label="宣传图片" label-width="100" style="width:100%" v-if="ismall==1 && createbrand.type==1 && createbrand.granttype==2">
                  <template slot-scope="scope">
                      <div style="float:left;width:70%;padding:2px;border:1px dashed #666666;border-radius:6px" v-loading="createbrand.bannerthumbloading">
                        <a @click="addbanneruploadgrantimg" style="float:left;cursor:pointer">
                          <img :src="createbrand.bannerthumb=='' ? require('../../assets/default_img.png') : createbrand.bannerthumb" 
                          style="float:left;width:100%;border-radius:6px"/>
                        </a>
                      </div>
                      <div style="display:inline-block;width:100%;font-size:12px;padding:5px 0;color:#F56C6C">建议尺寸：392px * 184px，大小不超过500k</div>
                  </template>
              </el-form-item>
              -->

              <el-form-item label="授权证书" label-width="100" style="width:100%" v-if="ismall==1 && createbrand.type==1">
                  <template slot-scope="scope">
                      <div style="float:left;width:50%;padding:2px;border:1px dashed #666666;border-radius:6px" v-loading="createbrand.imgloading">
                        <a @click="adduploadgrantimg" style="float:left;cursor:pointer">
                          <img :src="createbrand.grantthumb=='' ? require('../../assets/apdefault.jpg') : createbrand.grantthumb" 
                          style="float:left;width:100%;border-radius:6px"/>
                        </a>
                      </div>
                  </template>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="createbrandDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="createbrandLoading" @click="createbrandSave">保 存</el-button>
          </div>
      </el-dialog>


      
      <el-dialog title="编辑品牌" :visible.sync="updatebrandDialog" width="30%" top="15vh">
          <input @change="filecreateminiChange($event)" type="file" id="upload_file" style="display:none">
          <el-form ref="update" :model="update" label-width="100px" size="small">
            <el-form-item label="品牌名称">
               <el-input v-model="updatebrand.name"></el-input>
            </el-form-item>
            <el-form-item label="品牌LOGO">
               <template>
                  <div v-loading="updatebrand.loading">
                  <a style="float:left;width:60%;padding:2px;border:1px solid #dddddd;box-shadow:5px 5px 10px #999999;border-radius:6px;cursor:pointer" @click="updateuploadthumb">
                    <img :src="updatebrand.showthumb!='' ? updatebrand.showthumb : require('../../assets/default_img.png')" 
                    style="float:left;width:100%;border-radius:6px"/>
                  </a>
                  <div style="display:inline-block;width:100%;font-size:12px;padding:5px 0;color:#F56C6C">建议尺寸：392px * 184px，大小不超过500k</div>
                  </div>
               </template>
            </el-form-item>
            
            <!--
            <el-col :span="23">
              <el-form-item label="展示宣传图">
              	<el-tag type="danger">温馨提示：建议上传345px * 168px的图片，图片的大小不超过300k</el-tag>
                <input @change="filecreateChange($event,'update')" type="file" id="upload_file">
              </el-form-item>
            </el-col>
            <el-col :span="23">
              <el-form-item>
                  <img :src="updatebrand.showthumbbanner" style="width:70%;" v-if="updatebrand.bannerthumb!='' && updatebrand.bannerthumb!=null">
                  <img src="../../assets/default_img.png" style="width:70%;" v-if="updatebrand.bannerthumb=='' || updatebrand.bannerthumb==null">
              </el-form-item>
            </el-col>
            <el-col :span="23">
            	<el-form-item label="绑定品类">
            		<el-checkbox v-for="(item,index) in updatebrand.cate" v-model="item.status" :key="index">{{item.name}}</el-checkbox> 
                </el-form-item>
            </el-col>
            
            <el-col :span="23">&nbsp;</el-col>
            <el-col :span="23">
            	<el-form-item label="线上商城展示">
            		<template slot-scope="scope">
              	    	<el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="updatebrand.showmallstatus"  @change="changeshowmall('update')"></el-switch>
          	  		</template>
                </el-form-item>
            </el-col>
            <el-col :span="23">
            	<el-form-item label="绑定分类">
            		<el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="updatebrandCurrent()">新增绑定分类</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
              		<el-tag type="danger">温馨提示：用于宠老板进货商城分类搜索品牌信息</el-tag>
                </el-form-item>
            </el-col>
            <el-col :span="23">
            	<el-form-item>
            		<el-table :data="updatebrand.category" border>
            			<el-table-column prop="catname" label="分类名称">
            				<template slot-scope="scope">
            					<el-input v-model="updatebrand.category[scope.$index].catname" @focus="addbrandcate(scope.row,scope.$index,'update')" style="width:70%" readonly></el-input>
            				</template>
            			</el-table-column>
		          		<el-table-column label="操作" align="center" width="90">
		          			<template slot-scope="scope">
		          				<el-button type="danger" size="small" icon="el-icon-circle-close-outline" circle @click="delupdatebrandcate(scope.$index)"></el-button>
		          			</template>
		          		</el-table-column>
		        	</el-table>
            	</el-form-item>
            </el-col>
            -->
            
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="updatebrandDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="updatebrandLoading" @click="updatebrandSave">保 存</el-button>
          </div>
      </el-dialog>
      
      <el-dialog title="选择绑定品牌分类" :visible.sync="brandcategoryDialog" width="30%">
      	  <el-form>
              <el-col :span="23">
	              <el-form-item>
	                  <el-cascader :options="brandcategorylists" v-model="selectcategory.brandcategoryid"></el-cascader>
	              </el-form-item>
              </el-col>            
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="brandcategoryDialog = false">取 消</el-button>
            <el-button type="primary" :loading="brandcategoryLoading" @click="brandcategorysave">保 存</el-button>
          </div>
      </el-dialog>
      
      <!-- 品牌进行授权 -->
      <el-dialog title="提交平台审核申请" :visible.sync="settingbrandDialog" width="45%" top="5vh">
          <input type="file" id="coverthumb" @change="uploadallfiles($event)" style="display:none"/>
          <input type="file" id="updatebanner" @change="uploadupdatebannerfiles($event)" style="display:none"/>
          <el-tag type="danger" size="small">温馨提示：该操作主要是将代理商的品牌信息进行授权，只有经过授权且通过平台审核的品牌才能在商城进行售卖</el-tag>
          <el-form :inline="true" class="demo-form-inline brand-mall-infos" size="small" style="margin-top:20px" v-loading="settingbrandsquery.loading">
              <el-form-item  label="品牌授权类型" label-width="120" style="width:100%">
                  <el-select v-model="settingbrandsquery.granttype" filterable placeholder="请选择授权方式" @change="changegrant">
                      <el-option v-for="(item,index) in granttypelists" :label="item.name" :value="item.id" :key="index"></el-option>
                  </el-select>
                  <el-tooltip placement="top">
                      <div slot="content">
                          授权品牌为从品牌方处代理的品牌<br/>
                          自主品牌为自己公司研发的自有品牌
                      </div>
                      <div class="brand-warning-notice">?</div>
                  </el-tooltip>
              </el-form-item>
              <el-form-item  label="申请的平台授权品牌" label-width="120" style="width:100%">
                  <el-select v-model="settingbrandsquery.sysbrandid" filterable clearable placeholder="请选择品牌" @change="changesysthumb">
                      <el-option v-for="(item,index) in sysbrandlists" :label="item.showlable" :value="item.id" :key="index">
                          <span style="float: left">{{item.companyname}}</span>
                          <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
                      </el-option>       
                  </el-select>
              </el-form-item>
              
              <el-form-item label="授权区域" label-width="100" style="width:100%">
                  <template slot-scope="scope">
                      <el-button type="warning" round size="small" @click="settingarea">设置授权区域</el-button>
                  </template>
              </el-form-item>
              <el-form-item label="授权时间" label-width="100" style="width:100%" v-if="settingbrandsquery.granttype==1">
                  <el-date-picker	v-model="settingbrandsquery.date" type="daterange" style="width:100%"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd" :unlink-panels="false">
                  </el-date-picker>
              </el-form-item>
              
              <!--
              <el-form-item label="宣传图片" label-width="100" style="width:100%" v-if="ismall==1 && settingbrandsquery.granttype==2">
                  <template slot-scope="scope">
                      <div style="float:left;width:70%;padding:2px;border:1px dashed #666666;border-radius:6px" v-loading="settingbrandsquery.bannerthumbloading">
                        <a @click="updatebanneruploadgrantimg" style="float:left;cursor:pointer">
                          <img :src="settingbrandsquery.bannerthumb=='' ? require('../../assets/default_img.png') : settingbrandsquery.bannerthumb" 
                          style="float:left;width:100%;border-radius:6px"/>
                        </a>
                      </div>
                  </template>
              </el-form-item>
              -->

              <el-form-item label="授权证书" label-width="100" style="width:100%">
                  <template slot-scope="scope">
                      <div style="float:left;width:50%;padding:2px;border:1px dashed #666666;border-radius:6px" v-loading="settingbrandsquery.imgloading">
                        <a @click="uploadgrantimg" style="float:left;cursor:pointer">
                          <img :src="settingbrandsquery.grantthumb=='' ? require('../../assets/apdefault.jpg') : settingbrandsquery.grantthumb" 
                          style="float:left;width:100%;border-radius:6px"/>
                        </a>
                      </div>
                  </template>
              </el-form-item>
              <el-form-item label="审核状态" label-width="100" style="width:100%;padding-bottom:10px;border-bottom:1px dashed #666666" v-if="settingbrandsquery.status > 0">
                  <template slot-scope="scope">
                      <div style="float:left;font-size:13px" v-if="settingbrandsquery.status==1">审核中</div>
                      <div style="float:left;font-size:13px" v-if="settingbrandsquery.status==2">审核通过</div>
                      <div style="float:left;font-size:13px" v-if="settingbrandsquery.status==3">审核失败</div>
                  </template>
              </el-form-item>
              <el-col :span="24" style="margin-bottom:30px">
              <el-col :span="24" style="font-size:13px;margin-bottom:10px;color:#000" v-for="(item,index) in settingbrandsquery.follow" :key="index">
                  <el-tooltip class="item" effect="dark" :content="item.reason" placement="top">
                  <el-col :span="12" style="overflow:hidden;white-space:nowrap;text-overflow: ellipsis;">{{item.reason}}</el-col>
                  </el-tooltip>
                  <el-col :span="6" align="center">{{item.pushtype==0 ? item.username : '系统平台'}}</el-col>
                  <el-col :span="6">{{item.inputtime}}</el-col>
              </el-col>
              </el-col>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="settingbrandDialog = false">取 消</el-button>
            <el-button size="small" type="primary" :loading="settingbrandsquery.loading" @click="updatebrandgrant">保 存</el-button>
          </div>
      </el-dialog>

      <!-- 设置品牌可售区域 -->
      <el-dialog title="设置品牌可售区域" :visible.sync="settingDialog" width="45%" top="5vh">
            <el-tree 
                :data="citylists" 
                v-loading="settingbrandsquery.settingloading"
                ref="citytreeinfos" 
                highlight-current 
                show-checkbox node-key="id" 
                @check="selectcityids"
            >
            </el-tree>
      </el-dialog>

      <!-- 设置品牌可售区域 -->
      <el-dialog title="设置品牌可售区域" :visible.sync="addsettingDialog" width="45%" top="5vh">
            <el-tree 
                :data="addcitylists" 
                v-loading="createbrand.settingloading"
                ref="addcitytreeinfos" 
                highlight-current 
                show-checkbox node-key="id" 
                @check="addselectcityids"
            >
            </el-tree>
      </el-dialog>

      <!-- 手动新增品牌信息 -->
      <el-dialog title="手动添加品牌信息" :visible.sync="createhandlequery.dialog" width="25%" top="15vh">
          <input type="file" id="handelcoverthumb" @change="uploadhandlefiles($event)" style="display:none"/>
          <el-form :inline="true" class="brand-mall-infos" size="small">
              <el-form-item  label="品牌名称" label-width="120" style="width:100%">
                  <el-input type="text" v-model="createhandlequery.name" />
              </el-form-item>
              <el-form-item  label="品牌logo" label-width="120" style="width:100%">
                  <template>
                  <a @click="uploadhandelimg" style="float:left;width:80%;cursor:pointer" v-loading="createhandlequery.loading">
                      <img :src="createhandlequery.thumb=='' ? require('../../assets/default_img.png') : createhandlequery.thumb" style="float:left;width:100%;border-radius:6px"/>
                  </a>
                  <div style="display:inline-block;width:100%;font-size:12px;padding:5px 0;color:#F56C6C">建议尺寸：392px * 184px，大小不超过500k</div>
                  </template>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="createhandlequery.dialog = false">取 消</el-button>
            <el-button size="small" type="primary" @click="savehandlebrand">保 存</el-button>
          </div>
      </el-dialog>

      
  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作功能权限
      url:this.GLOBAL.domain+"Product/index",
      transitionshow:true,
      brand_total_rows:0,  
      brandquerylists:[],
      brandlistLoading:false,
      ismallgoods:[],
      statuslists:[{id:1,name:'未审核'},{id:2,name:'审核通过'},{id:3,name:'审核失败'}],
      brandquery:{
        act:'listsnew',
        token:this.$cookies.get('token'),
        status:'',
        key:'',
        ischange:false,
        rollpage: 10, // 页大小
        p: 1
      },
      addbrandtypelists:[{id:1,name:'自主添加'},{id:2,name:'从平台现有品牌中添加'}],
      addcitylists:[],
      createbrand: {
          act:'addnew',
          token:this.$cookies.get('token'),
          loading:false,
          type:'1',
          sysbrandid:'',
          sysbrandthumb:'',
          name:'',
          thumb:'',	
          bannerthumb:'',
          granttype:'',
          date:[],
          grantthumb:'',
          cityids:'',
          imgloading:false,
          imgloading1:false,
          bannerthumbloading:false,
          settingloading:false,
      },
      selectcategory: {
      	  brandcategoryid:'',
      	  index:'',
      	  type:'',
      },
      createbrandDialog:false,
      createbrandLoading:false,
      updatebrandDialog:false,
      updatebrandLoading:false,
      updatebrand: {
      	  id:'',
          act:'updatebrandnew',
          token:this.$cookies.get('token'),
          name:'',
          thumb:'',
          bannerthumb:'',
          showthumb:'',
          showthumbbanner:'',
          cate:[
          	{id:1,name:'狗狗','status':false},
          	{id:2,name:'猫猫','status':false},
          	{id:3,name:'小宠','status':false},
          	{id:4,name:'猫狗通用','status':false},
          	{id:9,name:'其它','status':false},
          ],
          category:[],
          showmallstatus:true,
          isshowmall:0,	
          loading:false,
      },
      brandcategoryDialog:false,
      brandcategorylists:[],
      brandcategoryLoading:false,
      ismall:false,

      settingbrandDialog:false,
      sysbrandlists:[],
      citylists:[],
      granttypelists:[{id:1,name:'授权品牌',msg:'平台已有品牌，需要授权'},{id:2,name:'自主品牌',msg:'代理商或品牌方自主添加的品牌'}],
      settingbrandsquery: {
          act:'grantbrands',
          token:this.$cookies.get('token'),
          granttype:1,
          sysbrandid:'',
          sysbrandthumb:'',
          brandid:'',
          brandname:'',
          brandthumb:'',
          bannerthumb:'',
          grantthumb:'',
          cityids:[],
          status:'',
          date:[],
          verifylists:[],
          loading:false,
          imgloading:false,
          bannerthumbloading:false,
          settingloading:false,
      },
      settingDialog:false,
      addsettingDialog:false,

      createhandlequery: {
          dialog:false,
          loading:false,
          name:'',
          thumb:'',
      },
      
    }
  },
  
  mounted(){
  	this.getactionauth();
	this.getbrandlists();
    this.getismall();
  },
  
  methods:{

      /** 点击上传品牌图片 **/
      uploadhandelimg() {
          document.getElementById('handelcoverthumb').click();
      },

      /** 获取批量主图回传信息 **/
	  uploadhandlefiles(el) {
          this.createhandlequery.loading=true;
		  var resource = this.$resource(this.GLOBAL.uploadUrl);
	      var formData = new FormData();
	      formData.append('file', el.target.files[0]);
          formData.append('sys_type', 'cz');
          formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	      resource.save(formData).then((res) => {
		      var data=JSON.parse(Base64.decode(res.body.Data));
		      if(data.Result > 0) {
		          this.$message.error(data.msg);
                  this.createhandlequery.loading=false;
		      }else {
				  this.createhandlequery.thumb=this.GLOBAL.staticUrl+data.imgsrc;     	
                  this.createhandlequery.loading=false;
		      }
		  }).catch((res) => {
		      this.createhandlequery.loading=false;
		  });
		  el.target.value = '';
	  },

      /** 保存手动添加的品牌信息 **/
      savehandlebrand() {
          this.createbrand.sysbrandid='';
          this.createbrand.sysbrandthumb='';
          this.createbrand.name=this.createhandlequery.name;
          this.createbrand.thumb=this.createhandlequery.thumb;	
          this.createhandlequery.dialog=false;
      },



     /** 获取手动新增品牌界面 **/
     addhandlebrands() {
         this.createhandlequery.dialog=true;
         this.createhandlequery.name='';
         this.createhandlequery.thumb='';
     },


    /** 切换获取信息途径 **/
    changecreatetype() {
        this.createbrand.sysbrandid='';
        this.createbrand.sysbrandthumb='';
    },


    /** 选择商品信息 **/
    changeaddthumb() {
        var _this=this;
        _this.createbrand.sysbrandthumb='';
        this.sysbrandlists.forEach(function(item,i) {
            if(item.id==_this.createbrand.sysbrandid) {
              _this.createbrand.sysbrandthumb=item.logo;
              _this.createbrand.sysbrandid=item.id;
              _this.createbrand.name=item.companyname;
              _this.createbrand.thumb=item.logo;
            }
        });
    },


    /** 设置可售区域 **/
    settingarea() {
        this.settingDialog=true;
        this.citylists=[];
        this.settingbrandsquery.settingloading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.save({act:'getcitylists',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.settingbrandsquery.settingloading=false;
          }else{
              this.citylists=JSON.parse(Base64.decode(res.data.Data));
              this.$refs.citytreeinfos.setCheckedKeys(this.settingbrandsquery.cityids);
              this.settingbrandsquery.settingloading=false;
          }
        }).catch((res) => {
            this.settingbrandsquery.settingloading=false;
        });

    },

    /** 设置可授权区域 **/
    addsettingarea() {
        this.addcitylists=[];
        this.addsettingDialog=true;
        this.createbrand.settingloading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.save({act:'getcitylists',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.createbrand.settingloading=false;
          }else{
              this.addcitylists=JSON.parse(Base64.decode(res.data.Data));
              this.$refs.addcitytreeinfos.setCheckedKeys(this.createbrand.cityids);
              this.createbrand.settingloading=false;
          }
        }).catch((res) => {
            this.createbrand.settingloading=false;
        });
    },


    /** 提交品牌授权信息 **/
    updatebrandgrant() {
        this.settingbrandsquery.loading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.save(this.settingbrandsquery).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.settingbrandsquery.loading=false;
          }else{
              this.settingbrandsquery.loading=false;
              this.settingbrandDialog=false;
              this.getbrandlists();
          }
        }).catch((res) => {
            this.settingbrandsquery.loading=false;
        });
    },


    /** 上传宣传图图片 **/
    updatebanneruploadgrantimg() {
      document.getElementById('updatebanner').click();
    },

    /** 获取批量主图回传信息 **/
	uploadupdatebannerfiles(el) {
        this.settingbrandsquery.bannerthumbloading=true;
		var resource = this.$resource(this.GLOBAL.uploadUrl);
	    var formData = new FormData();
	    formData.append('file', el.target.files[0]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    resource.save(formData).then((res) => {
		    var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		        this.$message.error(data.msg);
                this.settingbrandsquery.bannerthumbloading=false;
		    }else {
				this.settingbrandsquery.bannerthumb=this.GLOBAL.staticUrl+data.imgsrc;     	
                this.settingbrandsquery.bannerthumbloading=false;
		    }
		}).catch((res) => {
		    this.settingbrandsquery.bannerthumbloading=false;
		});
		el.target.value = '';
	},


    /** 上传资质图片 **/
    uploadgrantimg() {
      document.getElementById('coverthumb').click();
    },

    /** 获取批量主图回传信息 **/
	uploadallfiles(el) {
        this.settingbrandsquery.imgloading=true;
		var resource = this.$resource(this.GLOBAL.uploadUrl);
	    var formData = new FormData();
	    formData.append('file', el.target.files[0]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    resource.save(formData).then((res) => {
		    var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		        this.$message.error(data.msg);
                this.settingbrandsquery.imgloading=false;
		    }else {
				this.settingbrandsquery.grantthumb=this.GLOBAL.staticUrl+data.imgsrc;     	
                this.settingbrandsquery.imgloading=false;
		    }
		}).catch((res) => {
		    this.settingbrandsquery.imgloading=false;
		});
		el.target.value = '';
	},


    /** 上传宣传图片 **/
    addbanneruploadgrantimg() {
      document.getElementById('bannerthumb').click();
    },

    /** 获取宣传图片 **/
    adduploadbannerfiles(el) {
        this.createbrand.bannerthumbloading=true;
		var resource = this.$resource(this.GLOBAL.uploadUrl);
	    var formData = new FormData();
	    formData.append('file', el.target.files[0]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    resource.save(formData).then((res) => {
		    var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		        this.$message.error(data.msg);
                this.createbrand.bannerthumbloading=false;
		    }else {
				this.createbrand.bannerthumb=this.GLOBAL.staticUrl+data.imgsrc;     	
                this.createbrand.bannerthumbloading=false;
		    }
		}).catch((res) => {
		    this.createbrand.bannerthumbloading=false;
		});
		el.target.value = '';
    },


    /** 获取批量主图回传信息 **/
	adduploadallfiles(el) {
        this.createbrand.imgloading=true;
		var resource = this.$resource(this.GLOBAL.uploadUrl);
	    var formData = new FormData();
	    formData.append('file', el.target.files[0]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    resource.save(formData).then((res) => {
		    var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		        this.$message.error(data.msg);
                this.createbrand.imgloading=false;
		    }else {
				this.createbrand.grantthumb=this.GLOBAL.staticUrl+data.imgsrc;     	
                this.createbrand.imgloading=false;
		    }
		}).catch((res) => {
		    this.createbrand.imgloading=false;
		});
		el.target.value = '';
	},


    /** 上传资质图片 **/
    adduploadgrantimg() {
      document.getElementById('addcoverthumb').click();
    },

    /** 获取批量主图回传信息 **/
	adduploadallfiles(el) {
        this.createbrand.imgloading=true;
		var resource = this.$resource(this.GLOBAL.uploadUrl);
	    var formData = new FormData();
	    formData.append('file', el.target.files[0]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    resource.save(formData).then((res) => {
		    var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		        this.$message.error(data.msg);
                this.createbrand.imgloading=false;
		    }else {
				this.createbrand.grantthumb=this.GLOBAL.staticUrl+data.imgsrc;     	
                this.createbrand.imgloading=false;
		    }
		}).catch((res) => {
		    this.createbrand.imgloading=false;
		});
		el.target.value = '';
	},

    /** 上传品牌图片 **/
    addthumbuploadgrantimg() {
        document.getElementById('addthumb').click();
    },

    /** 获取批量主图回传信息 **/
	addthumbuploadallfiles(el) {
        this.createbrand.imgloading1=true;
		var resource = this.$resource(this.GLOBAL.uploadUrl);
	    var formData = new FormData();
	    formData.append('file', el.target.files[0]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
	    resource.save(formData).then((res) => {
		    var data=JSON.parse(Base64.decode(res.body.Data));
		    if(data.Result > 0) {
		        this.$message.error(data.msg);
                this.createbrand.imgloading=false;
		    }else {
				this.createbrand.thumb=this.GLOBAL.staticUrl+data.imgsrc;     	
                this.createbrand.imgloading1=false;
		    }
		}).catch((res) => {
		    this.createbrand.imgloading1=false;
		});
		el.target.value = '';
	},


    /** 修改提取品牌图片 **/
    changesysthumb() {
        var _this=this;
        _this.settingbrandsquery.sysbrandthumb='';
        this.sysbrandlists.forEach(function(item,i) {
            if(item.id==_this.settingbrandsquery.sysbrandid) {
              _this.settingbrandsquery.sysbrandthumb=item.logo;
            }
        });
    },

    /** 修改授权方式 **/
    changegrant() {
        this.settingbrandsquery.sysbrandid='';
        this.settingbrandsquery.sysbrandthumb='';
    },


    grandbrand(item) {
        if(item.verifystatus==2) {

            this.$confirm('该品牌已审核通过，您是否需要进行提交进行重新审核，重新审核期间品牌将下架无法销售 ?', '提示', { type: 'warning' }).then(() => {
                this.getgrandbrandinfos(item);
            }).catch(() => {
                
            });

        }else {
            this.getgrandbrandinfos(item);
        }
    },


    /** 设置授权品牌 **/
    getgrandbrandinfos(item) {
        this.settingbrandDialog=true;
        this.settingbrandsquery.loading=true;
        this.settingbrandsquery.brandid=item.id;
        this.settingbrandsquery.brandname=item.name;
        this.settingbrandsquery.brandthumb=item.thumb;
        this.settingbrandsquery.sysbrandid='';
        this.settingbrandsquery.sysbrandthumb='';
        this.settingbrandsquery.granttype=1;
        this.settingbrandsquery.grantthumb='';
        this.settingbrandsquery.bannerthumb='';
        this.settingbrandsquery.cityids=[];
        this.settingbrandsquery.status='';
        this.settingbrandsquery.date=[];
        this.settingbrandsquery.verifylists=[];

        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'getsysgrantinfos',id:item.id,token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.settingbrandsquery.loading=false;
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.settingbrandsquery.granttype=Number(result.granttype);
              this.settingbrandsquery.sysbrandid=result.sysbrandid;
              this.settingbrandsquery.sysbrandthumb=result.sysbrandthumb;
              this.settingbrandsquery.grantthumb=result.grantthumb && result.grantthumb!='' ? result.grantthumb : '';
              this.settingbrandsquery.bannerthumb=result.bannerthumb;
              this.settingbrandsquery.cityids=result.citys.mycitys;
              this.settingbrandsquery.status=result.status;
              this.settingbrandsquery.date=result.expiretime;
              this.settingbrandsquery.follow=result.follow;

              this.getsysbrandlists();
              this.settingbrandsquery.loading=false;
          }
        }).catch((res) => {
            this.settingbrandsquery.loading=false;
        });
    },

    /** 获取平台里可授权的品牌列表 **/
    getsysbrandlists() {
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'getsysbrands',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              this.sysbrandlists = JSON.parse(Base64.decode(res.data.Data));
          }
        }).catch((res) => {
            
        });
    },


    /** 获取当前商品是否有线上商城的销售权限 **/
    getismall() {
        var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
        resource.query({act:'getismall',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.ismall=result.ismall;
          }
        }).catch((res) => {
            
        });
    },

  	
  	/** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    //信息列表
    getbrandlists(){
        if(this.brandquery.ischange) {
            this.brandquery.p=1;
            this.brandquery.rollpage=10;
        }

        this.brandlistLoading = true;
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.save(this.brandquery).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
            	this.$message.error(res.data.Message);
            	this.brandlistLoading = false;
            }else{
            	var _this=this;
            	this.brandquerylists = JSON.parse(Base64.decode(res.data.Data));
            	this.brand_total_rows=parseInt(res.data.count);
            	this.brandlistLoading = false;
                if(this.brandquery.ischange) this.brandquery.ischange=false;

            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.brandlistLoading=false;
        });
    },
    
    brandpageSizeChange(val) {
        this.brandquery.rollpage = val;
        this.getbrandlists();
    },
    brandpageCurrentChange(val) {
        this.brandquery.p = val;
        this.getbrandlists();
    },
    
    //新增品牌信息
    addcreatebrandinfo() {
    	var _this=this;
        this.createbrand.type='1';
        this.createbrand.sysbrandid='';
        this.createbrand.sysbrandthumb='';
        this.createbrand.name='';
        this.createbrand.thumb='';
        this.createbrand.granttype='';
        this.createbrand.date=[];
        this.createbrand.grantthumb='';
        this.createbrand.bannerthumb='';
        this.createbrand.cityids=[];
        this.getsysbrandlists();
    	this.createbrandDialog=true;
    },
    
    createbrandSave() {
    	this.createbrandLoading=true;
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.save(this.createbrand).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.createbrandLoading=false;
			}else{
                this.$message.success(res.data.Message);
                this.createbrandDialog=false;
                this.createbrandLoading=false;
                this.getbrandlists();
            }
        }).catch((res) => {
        	this.$message.error(this.GLOBAL.errortext);
            this.createbrandLoading=false;
        });
    },

    addselectcityids() {
        var ids=this.$refs.addcitytreeinfos.getCheckedKeys();
        this.createbrand.cityids=[];
        this.createbrand.cityids=ids;
    },

    selectcityids() {
        var ids=this.$refs.citytreeinfos.getCheckedKeys();
        this.settingbrandsquery.cityids=[];
        this.settingbrandsquery.cityids=ids;
    },

    //上传品牌图片
    updateuploadthumb() {
        document.getElementById('upload_file').click();
    },
    
    //上传品牌缩略图
    filecreateminiChange(el) {
        this.updatebrand.loading=true;
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	var formData = new FormData();
    	formData.append('checktype', 'brandmini');
    	formData.append('file', el.target.files[0]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
	        if(data.Result > 0) {
	            this.$message.error(data.msg);
                this.updatebrand.loading=false;
	        }else {
	        	this.updatebrand.showthumb=this.GLOBAL.staticUrl+data.imgsrc;
	            this.updatebrand.thumb=data.imgsrc;
			    el.target.value = '';  
                this.updatebrand.loading=false;
	        }
	     }).catch((res) => {
	        this.updatebrand.loading=false;
	     });
    },
    
    //上传品牌banner图
    filecreateChange(el,type) {
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	var formData = new FormData();
    	formData.append('file', el.target.files[0]);
        formData.append('sys_type', 'cz');
        formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
	        if(data.Result > 0) {
	            this.$message.error(data.msg);
	        }else {
	        	if(type=='create') {
	        		this.createbrand.showthumbbanner=this.GLOBAL.staticUrl+data.imgsrc;
	            	this.createbrand.bannerthumb=data.imgsrc;
	        	}else {
	        		this.updatebrand.showthumbbanner=this.GLOBAL.staticUrl+data.imgsrc;
	            	this.updatebrand.bannerthumb=data.imgsrc;
	        	}
			    el.target.value = '';  
	        }
	     }).catch((res) => {
	        	
	     });
    },
    
    //新增品牌绑定分类条数
    addbrandCurrent() {
    	var param={pcatid:0,scatid:0,catname:''};
    	this.createbrand.category.push(param);
    },
    //编辑新增品牌绑定分类条数
    updatebrandCurrent() {
    	var param={pcatid:0,scatid:0,catname:''};
    	this.updatebrand.category.push(param);
    },
    //删除单条品牌分类信息
    delbrandcate(id) {
    	this.createbrand.category.splice(id,1);
    },
    //编辑删除单条品牌分类信息
    delupdatebrandcate(id) {
    	this.updatebrand.category.splice(id,1);
    },
    
    //搜索分类信息
    addbrandcate(item,index,type) {
    	var id=item.scatid;
    	var ids=[];
    	
    	if(type=='create') {
    		this.createbrand.category.forEach(function(e,i) {
    			if(e.scatid!=id && e.scatid!=0) ids.push(e.scatid)
    		});
    	}else {
    		this.updatebrand.category.forEach(function(e,i) {
    			if(e.scatid!=id && e.scatid!=0) ids.push(e.scatid)
    		});
    	}
    	
    	this.selectcategory.index=index;
    	this.selectcategory.brandcategoryid=[];
    	this.brandcategoryDialog=true;
    	var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.save({act:'brandcategorylists',token:this.$cookies.get('token'),ids:ids}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
            	this.brandcategorylists = JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    //保存选择的分类
    brandcategorysave() {
    	var _this=this;
    	var ids=this.selectcategory.brandcategoryid;
    	if(ids=='') {this.$message.error("请选择要绑定的分类");return false;}
    	
    	var pcatid=ids[0];
    	var scatid=ids[1];
    	var index=this.selectcategory.index;
    	
    	if(this.selectcategory.type=='create') {
    		this.createbrand.category[index].pcatid=pcatid;
	    	this.createbrand.category[index].scatid=scatid;
	    	
	    	this.brandcategoryLoading=true;
	    	this.brandcategorylists.forEach(function(e,i) {
	    		if(e.value==ids[0]) {
	    			e.children.forEach(function(ee,ii) {
	    				if(ee.value==ids[1]) {
	    					_this.createbrand.category[index].catname=ee.label;
	    				}
	    			});
	    		}
	    	});
	    	
    	}else {
    		this.updatebrand.category[index].pcatid=pcatid;
	    	this.updatebrand.category[index].scatid=scatid;
	    	
	    	this.brandcategoryLoading=true;
	    	this.brandcategorylists.forEach(function(e,i) {
	    		if(e.value==ids[0]) {
	    			e.children.forEach(function(ee,ii) {
	    				if(ee.value==ids[1]) {
	    					_this.updatebrand.category[index].catname=ee.label;
	    				}
	    			});
	    		}
	    	});
    		
    	}
    	
    	this.brandcategoryLoading=false;
    	this.brandcategoryDialog=false;
    },
    
    delbrandCurrent(item) {
    	this.$confirm('此操作将永久删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' }).then(() => {
            // 向请求服务端删除
            var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
            resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')}).then((res) => {
            	if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.$message.success('成功删除了' + item.name + '!');
                    this.getbrandlists();
                }
            }).catch((res) => {
                this.$message.error(this.GLOBAL.errortext);
            });
        }).catch(() => {
              this.$message.info('已取消操作!');
        });
    },
    
    //获取品牌信息
    editbrandCurrent(item) {
    	this.updatebrand.name='';
        this.updatebrand.showthumb='';
        this.updatebrand.showthumbbanner='';
        this.updatebrand.thumb='';	
        this.updatebrand.bannerthumb='';
        this.updatebrand.category=[];
    
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.save({ act:'getbrandinfos',id:item.id,token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
            	var _this=this;
            	var result = JSON.parse(Base64.decode(res.data.Data));
            	this.updatebrand.id=result.id;
            	this.updatebrand.name=result.name;
            	this.updatebrand.thumb=result.thumb;
            	this.updatebrand.bannerthumb=result.bannerthumb;
            	this.updatebrand.showthumb=this.GLOBAL.staticUrl+result.thumb;
            	this.updatebrand.showthumbbanner=this.GLOBAL.staticUrl+result.bannerthumb;
            	this.updatebrand.isshowmall=result.isshowmall;
            	this.updatebrand.showmallstatus=result.isshowmall==1 ? true : false;
            	
            	result.category.forEach(function(e,index) {
            		_this.updatebrand.category.push({pcatid:e.pcatid,scatid:e.scatid,catname:e.catname});
            	});
            	            	
            	this.updatebrand.cate.forEach(function(e,i) {
            		_this.updatebrand.cate[i].status=false;
            		result.cate.forEach(function(ee,ii) {
            			if(e.id==ee) _this.updatebrand.cate[i].status=true;
            		});
            	});
            	
            	this.selectcategory.type='update';  
                this.updatebrandDialog=true;
            }
        }).catch((res) => {
            
        });
    },
    
    //保存品牌信息
    updatebrandSave() {
    	this.updatebrandLoading=true;
    	var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.save(this.updatebrand).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.updatebrandLoading=false;
            }else{
            	this.$message.success("编辑品牌信息成功！");
            	this.updatebrandLoading=false;
                this.updatebrandDialog=false;
                this.getbrandlists();
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.updatebrandLoading=false;
        });
    },
    
    //开启/关闭品牌连同品牌下所属的线上商城商品是否展示
    changeshowmall(type) {
    	if(type=='create') {
    		if(this.createbrand.isshowmall==1) {
    			this.$confirm('温馨提示：该操作会关闭该品牌以及该 品牌所属的线上商城商品信息的展示，您确定要执行该操作吗？', '提示', { type: 'warning' }).then(() => {
					this.createbrand.isshowmall=0;
    				this.createbrand.showmallstatus=false;
	            }).catch(() => {
              		this.createbrand.isshowmall=1;
    				this.createbrand.showmallstatus=true;
          		});
    			
    		}else {
    			this.createbrand.isshowmall=1;
    			this.createbrand.showmallstatus=true;
    		}
    		
    	}else {
    		if(this.updatebrand.isshowmall==1) {
    			this.$confirm('温馨提示：该操作会关闭该品牌在进货商城中的展示，并下架进货商城里该品牌所属的商品，您确定要执行该操作吗？', '提示', { type: 'warning' }).then(() => {
					this.updatebrand.isshowmall=0;
    				this.updatebrand.showmallstatus=false;
	            }).catch(() => {
              		this.updatebrand.isshowmall=1;
    				this.updatebrand.showmallstatus=true;
          		});
    			
    		}else {
    			this.updatebrand.isshowmall=1;
    			this.updatebrand.showmallstatus=true;
    		}
    		
    	}
    },
    
    //开启/关闭是否是精品品牌开关
    changeismallgoods(index,item) {
    	var isgoods=0;
    	this.ismallgoods[index] ? isgoods=1 : isgoods=0;
    	
    	var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.save({act:"changeismallgoods",token:this.$cookies.get('token'),id:item.id,isgoods:isgoods}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{

            }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    }
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.brand-mall-infos .el-form-item__label {font-size:13px}
.brand-mall-infos .el-form-item__content {width:50%}
.brand-mall-infos-msg {float:left;margin-left:5%;font-size:13px;color:#F56C6C}
.brand-warning-notice {display:inline-block;margin-left:5%;font-size:12px;background:#e6a23c;line-height:12px;padding:2px 4px 2px 4px;border-radius:50%;color:#fff}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Productbrand.vue